var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar9 = function SvgDefaultAvatar9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 24.5c-5.8 0-10.4 4.6-10.4 10.6 0 5.5 4 9.2 9.5 9.2 2.6 0 5.2-.9 7-2.6-.4 7.4-3.2 10.6-7 10.6-2.6 0-4.5-1.6-5.8-3.6-.7-.9-1-1.3-1.6-1.3-.7 0-1.2.5-1.2 1.3 0 .7.4 1.8 1.2 2.9 1.5 2.2 4.2 3.9 7.7 3.9 6.8 0 11.5-6.3 11.5-16.2 0-10.2-5.2-14.8-10.9-14.8zm-5.9 9.3c0-3.6 2.1-6.3 5.4-6.3 3.2 0 6.2 2.9 6.5 11-.9 1.2-3.1 2.4-5.4 2.4-3.9 0-6.5-3.1-6.5-7.1z"
  })));
};
export default SvgDefaultAvatar9;